import Base from '../Pages/Base'
import ListCategoriasLegislacoesMunicipais from '../Pages/Categorias/List'
import FormCategoriasLegislacoesMunicipais from '../Pages/Categorias/Form'
import ListLegislacoesMunicipais from '../Pages/Concursos/List'
import FormLegislacoesMunicipais from '../Pages/Concursos/Form'

export default [
	{
		path: 'servicos/legislacoes-municipais',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategoriasLegislacoesMunicipais',
				component: ListCategoriasLegislacoesMunicipais,
				meta: {
					path: '/servicos/legislacoes-municipais',
					pai: 'Serviços',
					title: 'Admin - Legislações Municipais',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislações Municipais',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: 'novo',
				name: 'FormCategoriasLegislacoesMunicipais',
				component: FormCategoriasLegislacoesMunicipais,
				meta: {
					path: '/servicos/legislacoes-municipais',
					pai: 'Serviços',
					title: 'Admin - Legislações Municipais - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislações Municipais',
						class: '',
						active: false,
						url: '/servicos/legislacoes-municipais'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: 'editar/:id',
				name: 'FormCategoriasLegislacoesMunicipaisEditar',
				component: FormCategoriasLegislacoesMunicipais,
				meta: {
					path: '/servicos/legislacoes-municipais',
					pai: 'Serviços',
					title: 'Admin - Legislações Municipais - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislações Municipais',
						class: '',
						active: false,
						url: '/servicos/legislacoes-municipais'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id',
				name: 'ListLegislacoesMunicipais',
				component: ListLegislacoesMunicipais,
				meta: {
					path: '/servicos/legislacoes-municipais',
					pai: 'Serviços',
					title: 'Admin - Legislações Municipais - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislações Municipais',
						class: '',
						active: false,
						url: '/servicos/legislacoes-municipais'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormLegislacoesMunicipais',
				component: FormLegislacoesMunicipais,
				meta: {
					path: '/servicos/legislacoes-municipais',
					pai: 'Serviços',
					title: 'Admin - Legislações Municipais - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislações Municipais',
						class: '',
						active: false,
						url: '/servicos/legislacoes-municipais'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormLegislacoesMunicipaisEditar',
				component: FormLegislacoesMunicipais,
				meta: {
					path: '/servicos/legislacoes-municipais',
					pai: 'Serviços',
					title: 'Admin - Legislações Municipais - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislações Municipais',
						class: '',
						active: false,
						url: '/servicos/legislacoes-municipais'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
		]
	}
]